<div class="pricing-backdrop">
  <div class="pricing-modal">

    <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="top-icon">
      <i class="bi bi-lock"></i>
    </div>

    <h2 class="title text-center">Interview Practice Limit Reached</h2>
    <p class="text-center">You've used all available interview practice for your current plan. Please upgrade to continue.</p>
    <button class="btn-add w-100" (click)="goToUpgradePlan()">Upgrade Now</button>
  </div>
</div>